
import { defineComponent } from 'vue';
import AppVersion from './version.vue';

export default defineComponent({
  components: {
    AppVersion,
  },
  data: () => ({
    isActive: true,
    items: [
      {
        text: 'E-mail',
        icon: 'mdi-account',
        to: '/email',
      },
      {
        text: 'Security',
        icon: 'mdi-lock',
        to: '/security',
      },
      {
        text: 'Preferences',
        icon: 'mdi-cog',
        to: '/preferences',
      },
    ],
  }),
  props: {
    expanded: Boolean,
  },
  watch: {
    expanded(val) {
      this.isActive = val;
    },
  },
});
